import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsLegacyFieldLayoutRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-legacy-field-layout',
	path: '/jira/settings/issues/field-configuration/:fieldLayoutId',
};
